import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateDashboardByIdThunk } from "../common/updateDashboardByIdThunk";
import { RootState } from "@/store/store";
import { CategoryDetails } from "@/services/cloudchipr.api";
import { dashboardByIdDataSelector } from "@/store/dashboards/selectors/dashboard/dashboardByIdDataSelector";
import { getWidgetDataByTypeAndIdThunk } from "@/store/dashboards/thunks/widgets/common/getWidgetDataByTypeAndIdThunk";
import { generateWidgetInnerContentId } from "@/components/pages/dashboard/utils/helpers/widget/generateWidgetInnerContentId";
import { getDashboardByIdThunk } from "@/store/dashboards/thunks/dashboard/getDashboardByIdThunk";

export const updateDashboardDimensionFilterThunk = createAsyncThunk(
  "dashboards/updateDashboardDimensionFilter",
  async (
    {
      dashboardId,
      dimension_id,
      category_id,
    }: {
      dashboardId: string;
    } & CategoryDetails,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;

    const dashboard = dashboardByIdDataSelector(state, dashboardId);
    const widgetsData = dashboard?.widgets;

    await dispatch(
      updateDashboardByIdThunk({
        dashboardId,
        body: {
          category_details: { category_id, dimension_id },
        },
      }),
    );

    await dispatch(getDashboardByIdThunk(dashboardId));

    widgetsData?.forEach((widget) => {
      const widgetIsVisible = document.getElementById(
        generateWidgetInnerContentId(widget.id),
      );

      if (!widgetIsVisible) {
        return;
      }

      dispatch(
        getWidgetDataByTypeAndIdThunk({
          widgetId: widget.id,
          type: widget.type,
        }),
      );
    });
  },
);
